import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-out-of-stock-window',
  templateUrl: './out-of-stock-window.component.html',
  styleUrls: ['./out-of-stock-window.component.css']
})
export class OutOfStockWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/outofstock');
  }

}
